import { ProfileStatusDto } from 'services/generated';
import { profileApi } from 'store/slices/profile-api';
import { preloadQueries } from './preloading';

export async function getSignupStatus() {
  const [res] = await preloadQueries(
    profileApi.endpoints.getProfileStatus.initiate(),
  );

  const signupPages = getCurrentSignupPages(res.data!);
  return {
    active: res.data?.profile.statusCode == 'ACTIVE',
    defaultSignupPage: signupPages?.[0],
    allowedSignupPages: signupPages,
  };
}

function getCurrentSignupPages(data: ProfileStatusDto) {
  if (data.profile.statusCode == 'ACTIVE') return null;

  if (!data.emailVerified) return ['/auth/signup/verify-email'];

  if (!data.detailsCompleted) return ['/auth/signup/account-details'];

  if (!data.profile.termsAcceptedAt) return ['/auth/signup/tos'];

  return null;
}
